import { ArrowRight } from "lucide-react";

const TransformationSection = () => {
  const transformations = [
    {
      from: "De bloqueio criativo",
      to: "para conteúdo fluindo facilmente",
    },
    {
      from: "De desorganização",
      to: "para métricas claras e ações certas",
    },
    {
      from: "De paralisia",
      to: "para execução guiada passo a passo",
    },
    {
      from: "De ferramentas separadas",
      to: "para tudo em um único lugar",
    },
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            Do Zero ao Resultado em Semanas — Não em Meses
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Chega de travar, ficar perdido ou depender de mil ferramentas diferentes.
            <br />
            Com o MarketPro Tools, você tem clareza, direção e tudo organizado para finalmente vender online.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-foreground mb-8 text-center">
            O que muda na sua vida:
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {transformations.map((item, index) => (
              <div
                key={index}
                className="bg-card p-6 rounded-xl shadow-medium hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-4">
                  <div className="flex-1">
                    <p className="text-muted-foreground line-through mb-2">
                      {item.from}
                    </p>
                    <div className="flex items-center gap-2">
                      <ArrowRight className="w-5 h-5 text-primary flex-shrink-0" />
                      <p className="text-foreground font-semibold">
                        {item.to}
                      </p>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                      <span className="text-primary font-bold">✓</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransformationSection;
